module.exports = __webpack_public_path__ + "img/al8.f2e67bab.png";